import { render, staticRenderFns } from "./thirdClass.vue?vue&type=template&id=0b49b06e&scoped=true"
import script from "./thirdClass.vue?vue&type=script&lang=ts"
export * from "./thirdClass.vue?vue&type=script&lang=ts"
import style0 from "./thirdClass.vue?vue&type=style&index=0&id=0b49b06e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b49b06e",
  null
  
)

export default component.exports